export const API_NAME = "J-PAC3API";

export const GRANDATA_LOGO = `${process.env.PUBLIC_URL}/logo192.png`;
export const GRANDATA_ICON192 = `${process.env.PUBLIC_URL}/logo192.png`;

export const PAGE_SIZE = 10;
